import {Tag, Text} from '@shopify/polaris';

import type {AppliedFilterInterface} from '../../types';

import styles from './FilterTags.scss';

interface FilterTagsProps {
  appliedFilters: AppliedFilterInterface[];
  disabled?: boolean;
  onFiltersChange(appliedFilters: AppliedFilterInterface[]): void;
}

export function FilterTags({
  appliedFilters,
  disabled,
  onFiltersChange,
}: FilterTagsProps) {
  const filteredAppliedFilters = appliedFilters.filter(
    ({label}) => label !== '' && label !== null,
  );

  const hidden = filteredAppliedFilters.length < 1;

  const tagsMarkup = (
    <div className={styles.TagsContainer} aria-live="polite">
      {filteredAppliedFilters.map((filter) => {
        return (
          <Tag
            key={filter.key}
            onRemove={() => {
              filter.onRemove(filter.key);
              onFiltersChange(
                appliedFilters.filter((appliedFilter) => {
                  return appliedFilter.key !== filter.key;
                }),
              );
            }}
            disabled={disabled}
          >
            {/* We filter out empty strings and null labels */}
            {filter.label as string}
          </Tag>
        );
      })}
    </div>
  );

  return hidden ? (
    <Text variant="bodySm" as="span" visuallyHidden>
      {tagsMarkup}
    </Text>
  ) : (
    tagsMarkup
  );
}
